module.exports = __webpack_public_path__ + "img/btn_guide.72424ce1.svg";